import React, {Suspense, lazy} from 'react';
import {ROUTE_SYNC_LOG_DETAIL_REPORT, ROUTE_SYNC_LOG_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';
import {Spin} from 'antd';

const SyncLogReport = lazy( () =>
  import('../../../screens/SyncLogReportScreen')
    .then(module => ({default: module.SyncLogReportScreen})),
);

const SyncLogReportDetails = lazy( () =>
  import('../../../screens/SchedulerLogDetailsScreen')
    .then(module => ({default: module.SchedulerLogDetailsScreen})),
);

const SyncLogReportNavigation = [
  {
    path: ROUTE_SYNC_LOG_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <SyncLogReport />
      </Suspense>
    ),
  },
  {
    path: ROUTE_SYNC_LOG_DETAIL_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <SyncLogReportDetails />
      </Suspense>
    ),
  },
];
export default SyncLogReportNavigation;
